import $ from 'jquery';
import ScrollReveal from 'scrollreveal';
import branchBar from './modules/branch-bar';

Array.prototype.max = function() {
  return Math.max.apply(null, this);
};

// Bootstrap (v3) doesn't have proper module support, so we need to make jQuery global and `require` bootstrap
global.$ = global.jQuery = $;
require('bootstrap');

var sr = ScrollReveal({ scale: 1 });

//Initialize everything on document ready
$(document).ready(() => {
  branchBar.init();

  $(document).on('click', 'a[href^="#"]', function (event) {
    event.preventDefault();

    $('html, body').animate({
      scrollTop: $($.attr(this, 'href')).offset().top
    }, 300);
  });

  equalHeights();
  $(window).resize(equalHeights);

  sr.reveal('h1, blockquote, .ball1, .ball2, .ball3, .button, .column, .stand-out, .goals, .financial-goals');

  if ($(window).width() <= 767) {
    $('#secondary').addClass('open');
  } else {
    $('#menu-icon').addClass('open');
    $('#menu').addClass('open');
  }


  $('#menu-icon').click(function(event){
    event.preventDefault();

    if ($(this).hasClass('open')) {
      $(this).removeClass('open');
      $('#menu').removeClass('open');
    } else {
      $(this).addClass('open');
      $('#menu').addClass('open');
      $('#secondary').addClass('open');
    }
  });


  var s = 0;

  $(window).scroll(function(event){
    const current = $(this).scrollTop();

    if ($(window).width() <= 767) {
      if (current > s && current > 0){
        if (!$('#menu').hasClass('open')) {
          $('#secondary').removeClass('open');
        }
      } else {
        $('#secondary').addClass('open');
      }
    } else {
      if (current < 5) {
        $('#menu').addClass('open');
        $('#menu-icon').addClass('open');
      } else {
        if ($('#menu').hasClass('open')) {
          $('#menu').removeClass('open');
          $('#menu-icon').removeClass('open');
        }
      }
    }

    s = current;
  });

  function equalHeights() {
    if ($(window).width() >= 992) {
      setHeights([
        ['#ceo', '#ceo-letter'],
        ['#world-on-tyres', '.new-products'],
        ['.strong-value', '.progress-everywhere'],
        ['.close-to-customer', '.love-from-first > div'],
        ['.navigate-north p:nth-of-type(1)', '.love-from-first p:nth-of-type(2)'],
        ['.northern-knowledge h2', '.stable-growth h2', '.special-tyres h2'],
        ['.northern-knowledge p:first-of-type', '.stable-growth p:first-of-type', '.special-tyres p:first-of-type'],
        ['.northern-knowledge p:nth-of-type(2)', '.stable-growth p:nth-of-type(2)', '.special-tyres p:nth-of-type(2)'],
        ['#figures div:nth-of-type(1)', '#figures div:nth-of-type(2)'],
        ['#figures div:nth-of-type(3)', '#figures div:nth-of-type(4)'],
        ['#figures div:nth-of-type(5)', '#figures div:nth-of-type(6)'],
        ['#figures div:nth-of-type(7)', '#figures div:nth-of-type(8)'],
      ]);

      $('.love-from-first .subtitle').css('min-height', $('.navigate-north h2').outerHeight() - $('.love-from-first h2').outerHeight() - 1);

      if($(window).width() > 1199) {
        setHeights([
          ['#figures div:nth-of-type(1)', '#figures div:nth-of-type(2)', '#figures div:nth-of-type(3)'],
          ['#figures div:nth-of-type(4)', '#figures div:nth-of-type(5)', '#figures div:nth-of-type(6)'],
          ['#figures div:nth-of-type(7)', '#figures div:nth-of-type(8)', '#figures div:nth-of-type(9)'],
        ]);
      }
    } else {
      if ($(window).width() > 767) {
        setHeights([
          ['.new-products', '.northern-knowledge'],
          ['.special-tyres', '.stable-growth']
        ]);
      }
    }
  }

  function setHeights(pairs) {
    pairs.forEach(function(items) {
      var max = items.map(function(el){ return $(el).outerHeight(); }).max();

      items.forEach(function(el) {
        $(el).css('min-height', max);
      });
    });
  }
});
